'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _VstListItem = require('./VstListItem');

var _VstListItem2 = _interopRequireDefault(_VstListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40
};

var VstDropdown = function (_React$Component) {
  _inherits(VstDropdown, _React$Component);

  function VstDropdown(props) {
    _classCallCheck(this, VstDropdown);

    var _this = _possibleConstructorReturn(this, (VstDropdown.__proto__ || Object.getPrototypeOf(VstDropdown)).call(this, props));

    _this.state = {
      open: false
    };

    _this.menu = null;
    _this.portal = null;
    _this.onDocumentKeydown = _this.onDocumentKeydown.bind(_this);
    _this.onDocumentMouseUp = _this.onDocumentMouseUp.bind(_this);
    _this.onTargetMouseUp = _this.onTargetMouseUp.bind(_this);
    _this.onTargetKeydown = _this.onTargetKeydown.bind(_this);
    _this.afterClose = _this.afterClose.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.positionMenu = _this.positionMenu.bind(_this);
    _this.onApplyClick = _this.onApplyClick.bind(_this);
    _this.focusAtFirstChild = _this.focusAtFirstChild.bind(_this);
    return _this;
  }

  _createClass(VstDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _reactDom.findDOMNode)(this).addEventListener('scroll', this.closeMenu);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(np) {
      if (this.state.open) {
        this.renderMenu(np);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.afterClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var target = this.props.target;
      var className = target.props.className || '';

      return (0, _react.cloneElement)(target, {
        onClick: this.focusAtFirstChild,
        onMouseUp: this.onTargetMouseUp,
        onKeyDown: this.onTargetKeydown,
        className: className + ' ' + (this.state.open ? 'open' : ''),
        'aria-expanded': this.state.open,
        'aria-haspopup': true
      });
    }
  }, {
    key: 'getWinSize',
    value: function getWinSize() {
      var body = document.body;
      var elem = document.documentElement;
      return {
        innerWidth: window.innerWidth || Math.max(elem.clientWidth, body.clientWidth),
        innerHeight: window.innerHeight || Math.max(elem.clientHeight, body.clientHeight),
        scrollY: window.scrollY || elem.scrollTop || body.scrollTop || 0,
        scrollX: window.scrollX || elem.scrollLeft || body.scrollLeft || 0
      };
    }
  }, {
    key: 'onDocumentKeydown',
    value: function onDocumentKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE) {
        this.closeMenu();
      }
    }
  }, {
    key: 'onDocumentMouseUp',
    value: function onDocumentMouseUp(e) {
      var portal = (0, _reactDom.findDOMNode)(this.portal);
      if (portal && portal.contains(e.target) || e.button && e.button !== 0) return;
      e.stopPropagation();
      this.closeMenu();
    }
  }, {
    key: 'onTargetMouseUp',
    value: function onTargetMouseUp() {
      this.openMenu(this.props);
    }
  }, {
    key: 'onTargetKeydown',
    value: function onTargetKeydown(e) {
      if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.DOWN) {
        this.openMenu();
      }
    }
  }, {
    key: 'focusMenu',
    value: function focusMenu() {
      var portal = (0, _reactDom.findDOMNode)(this.portal);
      portal.firstChild.focus();
    }
  }, {
    key: 'openMenu',
    value: function openMenu(props) {
      var _this2 = this;

      if (!this.state.open) {
        this.setState({ open: true }, function () {
          _this2.renderMenu(props || _this2.props);
          _this2.focusMenu();
          if (_this2.props.onOpen) {
            _this2.props.onOpen();
          }
        });
      }
    }
  }, {
    key: 'focusAtFirstChild',
    value: function focusAtFirstChild() {
      if (this.dropdown.firstChild.firstChild.focus) {
        this.dropdown.firstChild.firstChild.focus();
      } else {
        this.dropdown.firstChild.focus();
      }
    }
  }, {
    key: 'afterClose',
    value: function afterClose() {
      document.removeEventListener('keydown', this.onDocumentKeydown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
      document.removeEventListener('touchstart', this.onDocumentMouseUp);
      document.removeEventListener('vst-dropdown.close', this.closeMenu);
      window.removeEventListener('resize', this.closeMenu);
      _reactDom2.default.unmountComponentAtNode(this.menu);
      document.body.removeChild(this.menu);
      document.body.removeChild(this.overlay);
      this.portal = null;
      this.menu = null;
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      this.setState({ open: false }, this.afterClose);
    }
  }, {
    key: 'positionMenu',
    value: function positionMenu() {
      var _this3 = this;

      var _props = this.props,
          horizontal = _props.horizontal,
          vertical = _props.vertical,
          customX = _props.customX,
          customY = _props.customY;

      var _getWinSize = this.getWinSize(),
          innerHeight = _getWinSize.innerHeight,
          innerWidth = _getWinSize.innerWidth,
          scrollX = _getWinSize.scrollX,
          scrollY = _getWinSize.scrollY;

      var targetNode = (0, _reactDom.findDOMNode)(this);
      var portalNode = (0, _reactDom.findDOMNode)(this.portal);
      var target = targetNode.getBoundingClientRect();
      var portal = portalNode.getBoundingClientRect();
      var menuX = void 0;
      var menuY = void 0;
      var originX = void 0;
      var originY = void 0;
      // let maxHeight;

      // calculate space above/below target
      var above = target.top;
      var below = innerHeight - target.bottom;
      // maxHeight = portal.height;
      if (horizontal === 'left') {
        // align left
        menuX = target.left + scrollX;
        originX = 'left';
        // out of bounds, move to right
        if (menuX + portal.width > innerWidth + scrollX) {
          menuX = target.right + scrollX - portal.width;
          originX = 'right';
        }
      } else {
        // align right
        menuX = target.right + scrollX - portal.width;
        originX = 'right';
        // out of bounds, move to left
        if (menuX < 0) {
          menuX = target.left + scrollX;
          originX = 'left';
        }
      }

      if (vertical === 'top') {
        // show at the top
        menuY = target.top - portal.height + scrollY;
        originY = 'bottom';
        // out of bounds, move to bottom if there is more space
        if (menuY < 0 && below > above) {
          menuY = target.bottom + scrollY;
          originY = 'top';
        }
      } else {
        // show at the bottom
        menuY = target.bottom + scrollY;
        originY = 'top';
        // out of bounds, move to top if there is more space
        if (menuY + portal.height > innerHeight + scrollY && above > below) {
          menuY = target.top - portal.height + scrollY;
          originY = 'bottom';
        }
      }

      if (originY === 'top') {
        // originY is top, which means show menu at the bottom
        if (portal.height > innerHeight - target.bottom) {
          // maxHeight = innerHeight - target.bottom - 10;
        }
      } else {
        // originY is top, which means show menu at the top
        if (portal.height > target.top) {
          // maxHeight = target.top - 10;
          menuY = scrollY + 10;
        }
      }

      if (customX && customY) {
        menuX = customX;
        menuY = target.top + customY;
        originY = 'right';
      }

      if (!this.props.isMobile) {
        // set initial style
        // this.menu.style.height = '0px'; // Disabling scroll on main menu for now..
        if (customX && customY) {
          this.menu.style.right = menuX + 'px';
        } else {
          this.menu.style.left = menuX + 'px';
        }
        this.menu.style.position = customX && customY ? 'absolute' : '';
        this.menu.style.top = menuY + 'px';
        this.menu.style.transform = 'scale3d(0.01, 0.01, 1)';
        this.menu.style.transformOrigin = originX + ' ' + originY;

        // do the animation with a slight delay
        setTimeout(function () {
          // Menu may be gone by this point if it unmounts
          if (_this3.menu) {
            _this3.menu.style.opacity = '1';
            // this.menu.style.height = `${maxHeight}px`;
            _this3.menu.style.transform = 'scale3d(1, 1, 1)';
            _this3.menu.style.transition = 'transform 0.2s ease';
          }
        }, 20);
      }
    }
  }, {
    key: 'onApplyClick',
    value: function onApplyClick() {
      if (this.props.onApplyClick) {
        this.props.onApplyClick();
        this.closeMenu();
      }
    }
  }, {
    key: 'renderMobileHeader',
    value: function renderMobileHeader() {
      return _react2.default.createElement(
        'header',
        { className: this.props.headerClassName },
        _react2.default.createElement(
          'div',
          { className: 'back-title' },
          this.props.showBackBtn && _react2.default.createElement(
            'button',
            { onClick: this.closeMenu },
            this.props.headerBackButton
          ),
          _react2.default.createElement(
            'h2',
            { tabIndex: 0 },
            this.props.headerTitle
          )
        ),
        this.props.showApplyBtn && _react2.default.createElement(
          'button',
          { onClick: this.onApplyClick },
          this.props.headerApplyButton
        )
      );
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu(props) {
      var _this4 = this;

      var className = props.className,
          vertical = props.vertical,
          scrollable = props.scrollable;


      if (!this.menu) {
        this.overlay = document.createElement('div');
        this.overlay.setAttribute('class', 'vst-dropdown-overlay');
        this.menu = document.createElement('div');
        if (this.props.isMobile) {
          this.menu.className = (0, _classnames2.default)('vst-dropdown-mobile vst-dropdown-' + vertical, className);
        } else {
          this.menu.className = (0, _classnames2.default)('vst-dropdown vst-dropdown-' + vertical, className);
        }
        document.body.appendChild(this.menu);
        document.body.appendChild(this.overlay);
        document.addEventListener('keydown', this.onDocumentKeydown);
        document.addEventListener('mouseup', this.onDocumentMouseUp);
        document.addEventListener('touchstart', this.onDocumentMouseUp);
        document.addEventListener('vst-dropdown.close', this.closeMenu);
        window.addEventListener('resize', this.closeMenu);
      }

      var closeMenu = this.closeMenu;
      var list = _react2.default.createElement(
        'div',
        { className: 'vst-list' },
        this.renderMobileHeader(),
        _react2.default.createElement(
          'ul',
          {
            ref: function ref(dropdown) {
              _this4.dropdown = dropdown;
            },
            style: {
              height: this.props.height,
              overflow: scrollable ? 'scroll' : 'visible'
            }
          },
          _react.Children.map(props.children, function (child, index) {
            if (!child.props.hidden) {
              return (0, _react.cloneElement)(child, {
                closeMenu: closeMenu,
                key: index,
                isMobile: _this4.props.isMobile,
                header: _this4.renderMobileHeader()
              });
            }
            return null;
          }),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement('div', {
              role: 'button',
              tabIndex: 0,
              onFocus: this.focusAtFirstChild
            })
          )
        )
      );

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, list, this.menu);
      this.positionMenu();
    }
  }]);

  return VstDropdown;
}(_react2.default.Component);

VstDropdown.propTypes = {
  children: _propTypes2.default.node.isRequired,
  target: _propTypes2.default.element.isRequired,
  onClose: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  className: _propTypes2.default.string,
  height: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  showBackBtn: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  onApplyClick: _propTypes2.default.func,
  showApplyBtn: _propTypes2.default.bool,
  headerClassName: _propTypes2.default.node,
  headerBackButton: _propTypes2.default.node,
  headerApplyButton: _propTypes2.default.node,
  headerTitle: _propTypes2.default.string,
  customX: _propTypes2.default.number,
  customY: _propTypes2.default.number,
  horizontal: _propTypes2.default.oneOf(['left', 'right']),
  vertical: _propTypes2.default.oneOf(['bottom', 'top'])
};

VstDropdown.defaultProps = {
  height: null,
  horizontal: 'left',
  vertical: 'bottom',
  customX: 0,
  customY: 0,
  headerTitle: 'Title',
  scrollable: false,
  showBackBtn: true,
  showApplyBtn: true,
  menuName: ''
};

VstDropdown.Item = _VstListItem2.default;

exports.default = VstDropdown;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstDropdown.js
 **/